import * as React from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import { Translate } from '../../../../../shared/LanguageService';

export type QueryFilterLabels = {
    search: string;
};

type ExternalProps = {
    query: string;
    onSearchQuery: (event: React.ChangeEvent<{ value: unknown; }>) => void;
};

type QueryFilterProps = {
    labels: QueryFilterLabels;
} & ExternalProps;

const QueryFilter = (props: QueryFilterProps) => {
    const { query, labels, onSearchQuery } = props;

    return (
        <Box sx={{ position: 'relative' }}>
            <TextField
                id="search-input"
                label={labels.search + '...'}
                fullWidth
                name={'searchQuery'}
                value={query}
                onChange={onSearchQuery}
                placeholder={labels.search}
            />
            <SearchIcon
                style={{
                    position: 'absolute',
                    right: '10px',
                    top: '18px',
                    fill: '#0000008a'
                }}
            />
        </Box>
    );
};

const QueryFilterTranslationLayer = (props: ExternalProps) => {
    const labels: QueryFilterLabels = {
        search: Translate('orders/list/bookings-calendar/search')
    };

    return <QueryFilter labels={labels} {...props} />;
};

export default QueryFilterTranslationLayer;
